export interface ErrorChainEntry {
  name: string;
  message: string;
  stack?: string;
}

function describeError(error: unknown): ErrorChainEntry {
  if (error instanceof Error) {
    return {
      name: error.name,
      message: error.message,
      ...(error.stack ? { stack: error.stack } : {}),
    };
  }
  return {
    name: "NonError",
    message: String(error),
  };
}

export function describeErrorChain(
  error: unknown,
  maxDepth = 5,
): ErrorChainEntry[] {
  const chain: ErrorChainEntry[] = [];
  let current: unknown = error;
  const seen = new Set<unknown>();
  while (chain.length < Math.max(0, maxDepth) && !seen.has(current)) {
    seen.add(current);
    chain.push(describeError(current));
    if (!(current instanceof Error) || !("cause" in current)) break;
    current = current.cause;
  }
  return chain;
}

export function isPrivateMemberAccessError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error);
  return /cannot (?:access|read from) private (?:method|accessor|field|member)/i
    .test(message);
}

export function isSafariBrowser(userAgent: string): boolean {
  return /\bSafari\//i.test(userAgent) &&
    !/\b(?:Chrome|Chromium|CriOS|Edg|EdgiOS|OPR|OPiOS|FxiOS)\//i.test(userAgent);
}
